import { render, staticRenderFns } from "./bundle_edit.vue?vue&type=template&id=81abeb2a"
import script from "./bundle_edit.vue?vue&type=script&lang=js"
export * from "./bundle_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports